import * as React from "react";

export const renderLeagueName = (leagueName: string, componentPrefix: string) => {
    return (
        <div className={`rj-ev-list__${componentPrefix}__league-name`}>
            {leagueName}
        </div>
    )
}